export default __webpack_public_path__ + "static/ak-cached/24h/media/acc-save-white.681fa763.svg";